export default __webpack_public_path__ + "static/media/btn-arrow-next.cbd8c159.svg";